import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from '../general/error-handling.service';

@Injectable({
  providedIn: 'root'
})
export class MyAssignmentService {

  backendUrl:string = environment.backendUrl; 

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) {}

  getMyAssignmentdata(): Observable<any> {
    return this.http
      .get<any>(`${this.backendUrl}/moduleAssignment/getModuleAssignmentsWithCalls`)
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`my_assignment: ${outcome}`);
        }),
        catchError(this.errorHandlingService.handleError<any>(`my_assignment`)),
      );
  }

  getModuleAssignmentsWithStatus(): Observable<any> {
    return this.http
      .get<any>(`${this.backendUrl}/moduleAssignment/getModuleAssignmentsWithStatus`)
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`my_assignment_with_status: ${outcome}`);
        }),
        catchError(this.errorHandlingService.handleError<any>(`my_assignment_with_status`)),
      );
  }
}
